import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';

class PaperS extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Paper Submission</h4>
            <div className="par">
            Submissions are to be uploaded to the submission/evaluation web site portal at: <a href="https://american-cse.org/drafts/" target="_blank" rel="noopener noreferrer">https://american-cse.org/drafts/</a> <br />
            However, before doing so, please read the instructions below.

                <br /><br />
                All accepted papers of all Research Tracks will be published by Springer Nature (<a href="https://www.springernature.com/" target="_blank" rel="noopener noreferrer">https://www.springernature.com/</a>)  in the proceedings of The 2025 International Conference on Large Language Models (LLM'25).
            <br/> <br />
            <b>PUBLISHER: </b>SPRINGER NATURE <br />
              <br />
              <b>Indexation:</b> <br />
              Scopus; DBLP, EI Engineering Index (Compendex, Inspec databases);
                   Springer Link; Google Scholar; Conference Proceedings Citation
                   Index (CPCI), part of Clarivate Analytics' Web of Science; ACM
                   Digital Library; IO-Port; MathSciNet; Zentralblatt MATH, and
                   others. Only about 5% of all journals and conference proceedings
                   reach the same high level of scientific indexing as LLM/CSCE
                   publications. 

              <br />
                
            </div>

            <h6 className="par_header">INSTRUCTIONS FOR SUBMISSION OF PAPERS FOR EVALUATION:</h6>
            <div className="par">
            For the submission of draft papers (ie, papers submitted for evaluation), any reasonable formatting/typesetting is acceptable. Authors of accepted papers will later receive specific typesetting instructions to prepare their final versions. The final papers are expected to use the standard Springer Nature typesetting format ("US letter" standard size): <br /><br />
            WORD template:  <a href="https://www.springer.com/gp/authors-editors/conference-proceedings/editors/word-template/19338734" target="_blank" rel="noopener noreferrer">https://www.springer.com/gp/authors-editors/conference-proceedings/editors/word-template/19338734</a> <br />
            LaTeX template: <a href="https://www.springer.com/gp/computer-science/lncs/new-latex-templates-available/15634678" target="_blank" rel="noopener noreferrer">https://www.springer.com/gp/computer-science/lncs/new-latex-templates-available/15634678</a> <br /><br />

            All submissions must be original and must not have been previously published or currently under consideration for publication elsewhere. <br /><br />

            For categories of papers and page limitations, refer to: <a href="https://www.american-cse.org/LLM2025/paper_categories" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/paper_categories</a>
          <br /><br />
          Submissions must be in either MS doc or pdf formats (only one files should be uploaded/submitted for each paper). The first page should include:

                <br/><br/>

                - Title of the paper <br/>
                - Name, affiliation, city, country, and email address of each author (identify the name of the Contact Author) <br/>
                - Abstract (about 100 words) <br/>
                - A maximum of 5 topical keywords that would best represent the work described in the paper <br/>
                
                <br />
                The actual paper can start from the first page (space permitting)
                <br/> <br/>
                Submissions are to be uploaded to the submission/evaluation web
                site portal at: <a target="_blank" href="https://american-cse.org/drafts/">https://american-cse.org/drafts/</a>

            </div>
            
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default PaperS;